/**
 * @function calculateTotal
 * @description Converti juste le prix et permet l'utilisqtion des euros devqnt le prix.
 * @param {number} price - price  à convertir dans euros

 */
export const formatPrice = (price: number): string => {
  const fixed = price?.toFixed(2);
  if (!fixed) return;
  const [intPart, decimalPart] = fixed?.split('.');
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
  return '€' + ' ' + formattedInt + ',' + decimalPart;
};
